import React from "react";

const LinkedInTemplatesListLoading = () => {
  const loadingRows = Array.from({ length: 8 });

  return (
    <>
      {loadingRows.map((_, index) => (
        <div className="templateItemLoading" key={index}>
          <div className="fileIconLoading linear-background"></div>
          <div className="templateInfoLoading">
            <div className="templateNameLoading linear-background"></div>
          </div>
          <div className="arrowIconLoading linear-background"></div>
        </div>
      ))}
    </>
  );
};

export default LinkedInTemplatesListLoading;
export { LinkedInTemplatesListLoading };
